import { useStore } from "vuex";
import { computed } from "vue";
export function useCurrentStructure() {
  const store = useStore();
  return computed(() => store.getters.currentStructure);
}
